var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCheckBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.57543 7.99991C4.39143 7.99991 4.21543 7.92391 4.08943 7.78991L0.847425 4.33725C0.594759 4.06925 0.608759 3.64725 0.876759 3.39525C1.14543 3.14325 1.56743 3.15658 1.81876 3.42458L4.56876 6.35191L10.1741 0.217246C10.4234 -0.0554209 10.8448 -0.0734209 11.1168 0.174579C11.3881 0.422579 11.4068 0.844579 11.1588 1.11591L5.06743 7.78258C4.94276 7.91991 4.76543 7.99858 4.58009 7.99991H4.57543Z",
    fill: "#394D5A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckBlack);
export default __webpack_public_path__ + "static/media/IconCheckBlack.0026fcf076667f6d06b3adfb5fdd6480.svg";
export { ForwardRef as ReactComponent };